<template>
  <div class="collapse-content-wrapper">
    <div class="title-container" @click="handleTitleClick">
      <i v-if="showLeftArrowIcon" class="arrow-icon left-arrow el-icon-arrow-down" :class="!collapse && 'is-collapse'"></i>
      <slot name="title" :title="title">
        <div class="title">{{ title }}</div>
      </slot>
      <i v-if="showRightArrowIcon" class="arrow-icon el-icon-arrow-down" :class="!collapse && 'is-collapse'"></i>
      <slot name="suffix"></slot>
    </div>
    <div ref="collapseContent" class="collapse-content" :style="cssStyle">
      <div class="content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    showLeftArrowIcon: {
      type: Boolean,
      default: false
    },
    showRightArrowIcon: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      collapse: false,
      cssStyle: {
        height: null
      }
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {
    this.refreshCollapse()
  },
  methods: {
    handleTitleClick () {
      this.collapse = !this.collapse
      this.refreshCollapse()
    },
    refreshCollapse (isNextTick) {
      const collapse = this.collapse
      if (collapse) {
        if (this.cssStyle.height) {
          this.cssStyle.height = '0px'
        } else {
          const height = this.$refs.collapseContent?.firstElementChild?.clientHeight
          if (height) {
            this.cssStyle.height = `${height}px`
            this.$nextTick(() => {
              setTimeout(() => {
                this.cssStyle.height = '0px'
              }, 0)
            })
          } else {
            this.cssStyle.height = '0px'
          }
        }
      } else {
        const el = this.$refs.collapseContent
        if (!el) {
          if (isNextTick) {
            this.cssStyle.height = ''
          } else {
            this.$nextTick(() => this.refreshCollapse(true))
          }
          return
        }
        const height = el.firstElementChild?.clientHeight
        if (height) {
          this.cssStyle.height = `${height}px`
          this.$nextTick(() => {
            setTimeout(() => {
              this.cssStyle.height = null
            }, 300)
          })
        } else {
          this.cssStyle.height = null
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.collapse-content-wrapper {
  .title-container {
    display: flex;
    align-items: center;
    font-size: 18px;
    height: 48px;
    line-height: 48px;
    font-weight: bold;
    cursor: pointer;

    .arrow-icon {
      margin-left: 15px;
      transition: all .3s;

      &.is-collapse {
        transform: rotate(-180deg);
      }
    }

    .left-arrow {
      margin-left: 0;
      margin-right: 15px;
    }
  }

  .collapse-content {
    transition: height .3s ease-in-out;
    overflow: hidden;

    .content {
      padding-bottom: 30px;
    }
  }
}
</style>
